import {pagination} from "../../../app/services/dataTemplates"

export default {

  truncateReports(state) {
    state.loaded = false

    state.collection = []

    state.pagination = Object.assign({}, pagination)
  },

  fillReports(state, payload) {
    state.collection = state.collection.concat(payload.data)

    state.pagination = payload.pagination

    state.loaded = true
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/reports/mutations.js